import { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { cmToPx } from 'helpers/utils';
import FenceElement from 'components/features/FenceCanvas/FenceElement/FenceElement';
import FenceSlope from 'components/features/FenceCanvas/FenceSlope/FenceSlope';
import style from './FenceElements.module.scss';

const FenceElements = ({ fence, fenceGroupDetails, editable = false, className = '' }) => {
  const fenceDesignRef = useRef(null);
  const { elements, totalFenceWidth, maxSlope } = fenceGroupDetails;
  const modal = useSelector((state) => state.modal);
  const lastElement = elements[elements.length - 1] || [];

  useEffect(() => {
    if (editable && fenceDesignRef.current) {
      fenceDesignRef.current.scrollTo({
        left: totalFenceWidth - fenceDesignRef.current.offsetWidth + 100,
        behavior: 'smooth',
      });
    }
  }, [lastElement.id, lastElement.width]);

  const isOpenElementAction = () => {
    return ['edit-element', 'remove-element'].includes(modal.activeName);
  };

  return (
    totalFenceWidth > 0 && (
      <div className={`${style.fence} ${editable ? style['fence-editable'] : ''} ${className}`} ref={fenceDesignRef}>
        <div
          className={`${style.fence_elements} ${
            editable && modal.props.id && isOpenElementAction() ? style['fence_elements-inactive'] : ''
          }
          ${editable ? style['fence_elements-editable'] : ''}`}
          style={{ minWidth: cmToPx(fenceGroupDetails.settings.maxWidth), width: cmToPx(totalFenceWidth) }}
        >
          {elements.length &&
            elements.map((element, index) => (
              <FenceElement
                key={element.id}
                className={`${style.element} ${
                  editable && modal.props.id === element.id && isOpenElementAction() ? style['element-active'] : ''
                }`}
                element={element}
                prevElement={elements[index - 1]}
                nextElement={elements[index + 1]}
                maxSlope={maxSlope}
                index={index}
                color={fence.settings.color}
                railDirection={fence.settings.railDirection}
                railColor={fence.settings.railColor}
                editable={editable}
              />
            ))}
        </div>
        <FenceSlope className={style.slope} fenceGroupDetails={fenceGroupDetails} />
      </div>
    )
  );
};

export default FenceElements;
